<template>
  <div>
      <cube-input placeholder="点击配置表格数据" @click.native="focusInput"></cube-input>
    <cube-dialog
      title="配置表格数据"
      width="500px"
      :fullscreen="false"
      :append-to-body="true"
      :visible.sync="dialogVisible"
    >
      <template slot="content">
        <div style="display:flex;justify-content:flex-end" class="mb-15">
          <cube-button type="primary" size="mini" @click="add">新增数据</cube-button>
        </div>
        <cube-table v-if="labelItem.option.columnDefs" :data="tableData" v-bind="labelItem.option">
          <cube-table-column v-for="(item,index) in labelItem.option.columnDefs" :key="index"  v-bind="item"/>
          <cube-table-column prop="operate" label="操作">
            <template slot-scope="scope">
              <div>
                <cube-button
                  plain
                  size="small"
                  type="primary"
                  icon="el-icon-edit-outline"
                  @click="handle('edit', scope)"
                />
                <cube-button
                  plain
                  size="small"
                  type="danger"
                  icon="el-icon-delete"
                  @click="handle('del', scope)"
                />
                <!-- <cube-button icon="el-icon-rank" plain size="small" type="primary" /> -->
              </div>
            </template>
          </cube-table-column>
        </cube-table>
      </template>
       <template slot="footer">
      <cube-button size="mini" plain @click="onClose">取消</cube-button>
      <cube-button type="primary" size="mini" @click="onConfirm">确定</cube-button>
    </template>
    </cube-dialog>

    <cube-dialog
      :title="computedTitle"
      width="500px"
      :fullscreen="false"
      :append-to-body="true"
      :visible.sync="editVisible"
    >
      <template slot="content">
        <el-form ref="form" :model="form" >
        <cube-form-item v-for="(item,index) in labelItem.option.columnDefs" :key="index" :prop="item.prop" :label="item.label"  :custom-width="23">
          <el-input
              v-model="form[item.prop]"
              :placeholder="`请输入${item.label}`"
            />
        </cube-form-item>
      </el-form>
      </template>
       <template slot="footer">
      <cube-button size="mini" plain @click="editVisible = false">取消</cube-button>
      <cube-button type="primary" size="mini" @click="onFormConfirm">确定</cube-button>
    </template>
    </cube-dialog>
  </div>
</template>
<script>
export default {
  name: 'TemplateFormTable',
  props: {
    value: {
      type: String,
      required: true
    },
    labelItem: {
      type: Object,
      required: () => {
        return {
          id: null,
          name: null
        }
      }
    }
  },
  data() {
    return {
      dialogVisible: false,
      tableData: [],
      editVisible: false,
      isEdit: false,
      editData: {},
      editIndex: 0,
      form: {}
    }
  },
  computed: {
    computedTitle() {
      return this.isEdit ? '编辑行数据' : '新增行数据'
    }
  },
  watch: {
    value: {
      handler(nv) {
        this.$set(this, 'tableData', JSON.parse(JSON.stringify(nv)))
      },
      deep: true,
      immediate: true
    }
  },
  created() {
    this.labelItem.option.columnDefs.forEach(item => {
      this.$set(this.form, item.prop, '')
    })
  },
  methods: {
    focusInput() {
      this.dialogVisible = true
    },
    onConfirm() {
      this.$emit('input', this.tableData)
      this.dialogVisible = false
    },
    onClose() {
      this.dialogVisible = false
    },
    onFormConfirm() {
      this.tableData.push({ ...this.form })
      this.editVisible = false
      this.editData = {}
      this.$refs.form.resetFields()
    },
    onFormClose() {

    },
    handle(type, scope) {
      if (type === 'edit') {
        this.isEdit = true
        this.editData = scope.row
        this.editIndex = scope.$index
        this.editVisible = true
      }
      if (type === 'del') {
        this.tableData.splice(scope.$index, 1)
      }
    },
    add() {
      this.isEdit = false
      this.editData = {}
      this.editVisible = true
    }
  }
}
</script>
